
/* eslint-disable */
const globModules = [
  {
    name: 'callout-brands',
    loader: () => import('./modules/callout-brands')
  },
  {
    name: 'event-promotion',
    loader: () => import('./modules/event-promotion')
  },
  {
    name: 'video-modal',
    loader: () => import('./modules/video-modal')
  }
];

export default globModules;
